import classNames from 'classnames/bind';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './LogoutForce.module.scss';

import { PrimaryButton } from '@/components/ui/kit/Button';
import ModalWrapper from '@/components/ui/ModalWrapper';
import { modalManager } from '@/libs/ModalContainer';

const cx = classNames.bind(styles);

const Modal = ({ data }) => {
  const navigate = useNavigate();

  const doOK = () => {
    navigate('/', { replace: true });

    modalManager.hide();
  };

  return (
    <ModalWrapper disableEscape className={cx('container')}>
      <div className={cx('message')}>
        A new login has been detected.
        <br />
        Your session will be terminated.
      </div>
      <div className={cx('wrapper')}>
        <div className={cx('info')}>IP Address : {data?.ip}</div>
      </div>
      <PrimaryButton text="OK" accent center onClick={doOK} />
    </ModalWrapper>
  );
};

export default Modal;
